import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { buttonText } from "../../utils/buttonText";
import { notificationText } from "../../utils/notificationText";

function DeleteModal(props) {
  const { item, deleteFolder, isDeleting } = props;
  return (
    <Modal show={props.show} onHide={props.onHide} centered>
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title>{notificationText("Delete Folder")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{notificationText("Are you sure you want to Delete this folder?")}</p>
        <p>
          {notificationText(
            "Or if you want to clear data only but keep the folder?"
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        {isDeleting ? (
          <Button variant="outline-danger" disabled>
            {buttonText("Deleting")}
          </Button>
        ) : (
          <Button
            variant="outline-danger"
            onClick={() => {
              deleteFolder(item.name, item.type);
            }}
          >
            {buttonText("Delete")}
          </Button>
        )}
        {isDeleting ? (
          <Button variant="outline-danger" disabled>
            {buttonText("Clearing")}
          </Button>
        ) : (
          <Button
            variant="outline-danger"
            onClick={() => {
              deleteFolder(item.name, item.type, true);
            }}
          >
            {buttonText("Clear Data")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
